import React from 'react';
import classnames from 'classnames'

const CommonInputField = ({label, type, name, placeholder, value, onChange, error, require, min, max,disabled}) => {
    return (

        <div className="form-group col-md-6 text-left">
            <label htmlFor="inputEmail4">{label} {require && <span className="text-danger">*</span>}</label>
            <input type={type} className={classnames(`form-control`,{
                'is-invalid': error
            })} name={name} id={name} placeholder={placeholder}
                   onChange={onChange} value={value} min={min?min:''} max={max?max:''} disabled={disabled}/>
            {error && <span className="text-danger">{error}</span>}
        </div>

    );
};

export default CommonInputField;